<template>
  <div v-loading="loading" class="full">
    <w-flow-map-title :rscPerfData="rscPerfData" :objtypeId="selectedNode.obj.objtypeId" />
    <div class="default-layout type01-layout">
      <div class="col row-half">
        <w-flow-map-user-process :rsc-perf-data="rscPerfData" :objtype-id="selectedNode.obj.objtypeId" />
        <w-flow-map-system-tab :systemTabData="rscPerfData"></w-flow-map-system-tab>
      </div>

      <div class="col row-full">
        <div class="flowmap-box">
          <!-- arrow -->
          <w-flow-map-flow-field
            :perfRecords="rscPerfData"
            label="송신량"
            perfKey="SYSSTAT/DB_CLIENT_SENDSIZE"
            :arrow-settings="{ arrowSize: 'small', arrowDirection: 'arrow-left', top: '200px' }">
          </w-flow-map-flow-field>
          <!-- arrow -->

          <!-- arrow -->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey=""
          :arrow-settings="{ top: '100px', arrowDirection: 'arrow-right', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <!-- arrow -->

          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey=""
          :arrow-settings="{ top: '458px', arrowDirection: 'arrow-right', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <div class="flowmap-header thema-dark">
            MySQL
          </div>
          <div class="flowmap-content">
            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_MAX_MEMORY_SIZE" label="Memory 최대 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_CURR_MEMORY_SIZE" label="Current Memory 사용량"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_SHARED_MEMORY_SIZE" label="Shared Memory 사용량"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_EACH_THREADS_MEMORY_SIZE" label="비 공유 메모리 사용량"></w-flow-map-item-label>
            </ul>

            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MEMSTAT/DB_BUF_CACHE_HITRATIO" :isValue="false" label="Buffer Cache 적중률">
                <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MEMSTAT/DB_BUF_CACHE_HITRATIO"></w-flow-map-progressbar>
              </w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_SORT_BUFFER_SIZE" label="Sort Buffer 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_JOIN_BUFFER_SIZE" label="Join Buffer 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_READ_BUFFER_SIZE" label="Read Buffer 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_KEY_BUFFER_SIZE" label="Key Buffer 크기"></w-flow-map-item-label>
            </ul>

            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_QUERY_CACHE_SIZE" label="Query Cache 전체 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_QCACHE_FREE_MEMORY" label="가용량"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_QCACHE_HITS" :isValue="false" label="적중률">
                <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_QCACHE_HITS"></w-flow-map-progressbar>
              </w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_QUERY_CACHE_TYPE" label="타입"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_SYSSTAT/DBMY_QUERIES" label="Query 개수"></w-flow-map-item-label>
            </ul>
            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_THREAD_CACHE_SIZE" label="Thread Cache 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_THREAD_CACHE_HITRATIO" :isValue="false" label="Thread Cache 적중률">
                <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_THREAD_CACHE_HITRATIO"></w-flow-map-progressbar>
              </w-flow-map-item-label>
            </ul>
            <ul class="flowmap-list is-border">
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="LOCK/DB_LOCK_USERATE" label="Lock 사용률">
                  <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="LOCK/DB_LOCK_USERATE"></w-flow-map-progressbar>
                </w-flow-map-item-label>
            </ul>
          </div>
        </div>
      </div>

      <div class="col row-full">
        <div class="flowmap-box">
          <!-- arrow -->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey=""
          :arrow-settings="{ top: '200px', arrowDirection: 'arrow-left', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->

          <!-- arrow -->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey=""
          :arrow-settings="{ top: '100px', arrowDirection: 'arrow-right', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <!-- arrow -->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey=""
          :arrow-settings="{ top: '458px', arrowDirection: 'arrow-right', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <div class="flowmap-header thema-dark">
            InnoDB
          </div>
          <div class="flowmap-content">
            <div class="flowmap-content-header">
              <ul class="flowmap-list">
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_INNODB_BUFFER_POOL_SIZE"></w-flow-map-item-label>
              </ul>
            </div>
            <ul class="flowmap-list is-border-a is-height">
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_INNODB_PAGE_SIZE" label="Page 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_INNODB_POOL_PAGES_TOTAL" label="Pages 전체 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_INNODB_POOL_PAGES_DATA" label="Pages Data 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_INNODB_POOL_PAGES_MISC" label="Pages misc 수"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_INNODB_POOL_WAIT_FREE" label="Wait Free 수"></w-flow-map-item-label>
            </ul>
            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_INNODB_LOG_BUFFER_SIZE" label="Log Buffer 전체크기"></w-flow-map-item-label>
            </ul>
            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_INNODB_THREAD_CONCURRENCY" label="Thread Concurrency 수"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_MEMSTAT/DBMY_INNODB_DATA_PENDING_FSYNCS" label="Data Pending Fsyncs 수"></w-flow-map-item-label>
            </ul>
          </div>
        </div>
      </div>

      <div class="col row-full">
        <div class="flowmap-box">
          <!-- arrow -->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey=""
          :arrow-settings="{ top: '200px', arrowDirection: 'arrow-left', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <div class="flowmap-header thema-dark">
            Disk Storage
          </div>
          <div class="flowmap-content">
            <ul class="flowmap-list is-border is-height">
              <li><i class="fas fa-bullseye"></i> <strong>Tablespace</strong></li>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="TABLESPACE/DB_TABLESPACE_USERATE" :isValue="false" label="사용률">
                <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="TABLESPACE/DB_TABLESPACE_USERATE"></w-flow-map-progressbar>
              </w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="TABLESPACE/DB_TABLESPACE_TOTSIZE" label="전체크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="TABLESPACE/DB_TABLESPACE_USEDSIZE" label="사용량"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="TABLESPACE/DB_TABLESPACE_AVSIZE" label="가용량"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_TABLESPACE/DBMY_TABLESPACE_DATA_USEDSIZE" label="데이터파일 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_TABLESPACE/DBMY_TABLESPACE_INDEX_USEDSIZE" label="인덱스파일 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_TABLESPACE/DBMY_TABLESPACE_DATA_FREE" label="데이터파일 가용량"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MY_TABLESPACE/DBMY_TABLESPACE_ROWS" label="레코드 수"></w-flow-map-item-label>
            </ul>
            <ul class="flowmap-list is-border">
              <li><i class="fas fa-bullseye"></i> <strong>Log</strong></li>

              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="DISK/DISK_USERATE" :isValue="false" label="DB 로그 F/S 사용률">
                <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="DISK/DISK_USERATE"></w-flow-map-progressbar>
              </w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="DISK/DISK_TOTSIZE" label="DB 로그 F/S 크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="DISK/DISK_USEDSIZE" label="DB 로그 F/S 사용량"></w-flow-map-item-label>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import FlowMapAPI from '@/api/performance/database/flow-map';
import WFlowMapSystemTab from '@/views/performance/node/database-flow-map/components/FlowMapSystemTab';
import WFlowMapTitle from '@/views/performance/node/database-flow-map/components/FlowMapTitle';
import WFlowMapUserProcess from '@/views/performance/node/database-flow-map/components/FlowMapUserProcess';
import WRscPerfEventTextLabel from '@/components/textLabel/RscPerfEventTextLabel';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';
import WFlowMapItemLabel from './components/FlowMapItemLabel';
import WFlowMapFlowField from './components/FlowMapFlowField';
import WFlowMapProgressbar from './components/FlowMapProgressbar';

export default {
  name: 'WMySqlFlowMap',
  props: {
    active: Boolean,
    selectedNode: {
      type: Object,
    },
  },
  components: {
    WFlowMapSystemTab,
    WRscPerfEventProgressBar,
    WRscPerfEventTextLabel,
    WFlowMapTitle,
    WFlowMapUserProcess,
    WFlowMapItemLabel,
    WFlowMapFlowField,
    WFlowMapProgressbar,
  },
  data() {
    return {
      loading: false,
      rscPerfData: {},
    };
  },
  watch: {
    selectedNode: {
      immediate: true,
      handler() {
        if (!this.active) {
          return;
        }
        // handler (to, from)
        // 선택된 DB가 변경될 때 수행해야할 로직 작성.
        this.loadData();
      },
    },
    /**
     * [Flow 맵] 탭 활성화 시 재로드
     * @param  {[type]} active [description]
     * @return {[type]}        [description]
     * @author jda
     */
    active(active) {
      if (active) {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        objtypeId: this.selectedNode.obj.objtypeId,
      };
      this.loading = true;
      FlowMapAPI.getRscPerfAndEventOfDatabase(params).then((response) => {
        if (response.data.success) {
          // 응답 데이터 처리
          this.rscPerfData = response.data.data[0];
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Flow 맵 정보', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Flow 맵 정보', false));
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/MySqlFlowMap.vue